import { render, staticRenderFns } from "./AlertPushForm.vue?vue&type=template&id=afea28b2&"
import script from "./AlertPushForm.vue?vue&type=script&lang=js&"
export * from "./AlertPushForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports